import { X, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useDismissedTutorials } from '@/hooks/useDismissedTutorials';
import instagramLogo from '@/assets/instagram-logo.png';
import tiktokLogo from '@/assets/tiktok-logo.png';
import amazonLogo from '@/assets/amazon-logo.svg';
import pinterestLogo from '@/assets/pinterest-logo.png';
import nikeLogo from '@/assets/nike-logo.svg';
import zaraLogo from '@/assets/zara-logo.svg';
import sheinLogo from '@/assets/shein-logo.svg';

interface ShareEducationBannerProps {
  itemCount: number;
  onOpenHowToSave: () => void;
}

const SOURCE_PILLS = [
{ name: 'Instagram', logo: instagramLogo },
{ name: 'TikTok', logo: tiktokLogo },
{ name: 'Amazon', logo: amazonLogo },
{ name: 'Pinterest', logo: pinterestLogo },
{ name: 'Nike', logo: nikeLogo },
{ name: 'Zara', logo: zaraLogo },
{ name: 'SHEIN', logo: sheinLogo },
{ name: 'Browser', logo: null },
{ name: 'Screenshots', logo: null }];


export function ShareEducationBanner({ itemCount, onOpenHowToSave }: ShareEducationBannerProps) {
  const { isDismissed, dismiss } = useDismissedTutorials();

  if (itemCount < 1 || itemCount > 3 || isDismissed('share_from_anywhere_tip')) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.3 }}
      className="relative rounded-2xl bg-muted/40 border border-border/50 p-4 mb-4 overflow-hidden cursor-pointer"
      onClick={onOpenHowToSave}>

      {/* Dismiss button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          dismiss('share_from_anywhere_tip');
        }}
        className="absolute top-2.5 right-2.5 p-1.5 rounded-full hover:bg-muted/50 transition-colors z-10"
        aria-label="Dismiss tip">

        <X className="w-3.5 h-3.5 text-muted-foreground" />
      </button>

      {/* Scrolling marquee row */}
      <div className="overflow-hidden rounded-xl mb-3 mr-4">
        <div
          className="flex items-center gap-2 w-max"
          style={{ animation: 'marquee 18s linear infinite' }}>

          {[...SOURCE_PILLS, ...SOURCE_PILLS].map((source, idx) =>
          <span
            key={`pill-${idx}`}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap bg-background/80 text-muted-foreground border border-border/40">

              {source.logo &&
            <img src={source.logo} alt={source.name} className="w-4 h-4 object-contain" />
            }
              {source.name}
            </span>
          )}
        </div>
      </div>

      {/* Prompt text */}
      <div className="flex items-center justify-between pr-5">
        <p className="text-sm text-muted-foreground leading-snug">
          See something you love?{' '}
          <span className="font-semibold text-foreground">Share it to WNTD</span>
        </p>
        <ChevronRight className="w-4 h-4 text-muted-foreground shrink-0" />
      </div>
    </motion.div>);

}